import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom"
import { useState,useEffect } from 'react';

import SendIcon from '@mui/icons-material/Send';


function InfoNavBar() {

  const [anchorElNav, setAnchorElNav] = React.useState(null);


  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

    const navigate = useNavigate()


       //go to Knowledge  
    const Knowledge =  () => {
        navigate('/')
        }

          //go to ClientContact  
    const InfoContact =  () => {
        navigate('/')
        }

   const GoToApp =  () => {
        navigate('/')
                }
         //go to home 
    const Home =  () => {
        navigate('/')
        }

  
  return (
    <div>
    <AppBar position="fixed" >
    <Container maxWidth="lx">
        <Toolbar disableGutters>
          <Typography 
          variant="h6"
          noWrap
          component="a"
          href="/"
          sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}>
              <img
                src={`${process.env.PUBLIC_URL}/logo-herb.png`}
                alt="HERB"
                style={{ height: 54, marginRight: 8 }}
              />
      </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                // Apply styles when the menu is open
                '&.MuiPaper-root': {
                  minWidth: '400px', // Adjust the width as needed
                  padding: '16px', // Add padding as needed
                },
                '& .MuiButton-root': {
                  fontSize: '20px', // Increase text size
                  color: '#0166FF', // Dodaj kolor tekstu
                },
              }}
            >
 <Button onClick={Home}  sx={{ my: 2, color: 'blue', display: 'block' }}>{("Home")}</Button>

<Button onClick={GoToApp}  sx={{ my: 2, color: 'blue', display: 'block' }}>{("Aplikacja")}</Button>
<Button onClick={InfoContact}  sx={{ my: 2, color: 'blue', display: 'block' }}>{("Kontakt")}</Button>
<Button onClick={Knowledge}  sx={{ my: 2, color: 'blue', display: 'block' }}>{("FAQ")}</Button>

            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'lato',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

<Button onClick={GoToApp}  sx={{ my: 2, color: 'white', display: 'block' }}>{("Aplikacja")}</Button>
<Button onClick={InfoContact}  sx={{ my: 2, color: 'white', display: 'block' }}>{("Kontakt")}</Button>
<Button onClick={Knowledge}  sx={{ my: 2, color: 'white', display: 'block' }}>{("FAQ")}</Button>

          </Box>
          <Box sx={{ flexGrow: 0}}>

          </Box>
        </Toolbar>
      </Container>
    </AppBar>
    <Box marginTop={8}>
</Box>
  </div>
  );
}
export default InfoNavBar;